import React, { Component } from "react";
import AccountCircle from "@material-ui/icons/AccountCircle";
import Button from "@material-ui/core/Button";
import FormHelperText from "@material-ui/core/FormHelperText";
import HomeIcon from "@material-ui/icons/Home";
import InputAdornment from "@material-ui/core/InputAdornment";
import IconButton from "@material-ui/core/IconButton";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import { withStyles } from "@material-ui/core/styles";
import { withRouter } from "react-router-dom";
import { setRoles } from "../../utility/user-actions";
import { redirectRoot } from "../../utility/navigate";

import axios from "../../api/axios-allure-docker";
import KodeLogo from "../KodeLogo/KodeLogo";
import { KodeGrid, KodeHaze, KodeNodes } from "../effects/KodeEffects";
import { WELCOME_PENDING_KEY } from "../KodeWelcome/KodeWelcome";

const styles = (theme) => ({
  root: {
    position: "relative",
    minHeight: "100vh",
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    [theme.breakpoints.up("md")]: {
      flexDirection: "row",
      alignItems: "center",
    },
  },
  brandPanel: {
    position: "relative",
    flex: "0 0 auto",
    padding: theme.spacing(6, 4, 2),
    [theme.breakpoints.up("md")]: {
      flex: "1 1 58%",
      padding: theme.spacing(8),
    },
  },
  brandContent: {
    position: "relative",
    zIndex: 1,
    maxWidth: 620,
    marginLeft: "auto",
  },
  eyebrow: {
    color: theme.palette.text.disabled,
    display: "block",
    marginBottom: theme.spacing(2),
  },
  headline: {
    marginBottom: theme.spacing(1),
  },
  poweredBy: {
    display: "block",
    color: theme.palette.text.disabled,
    marginBottom: theme.spacing(3),
  },
  // Фирменный приём KODE: акцентный span внутри белого заголовка.
  headlineAccent: {
    color: theme.palette.primary.main,
    display: "block",
  },
  lead: {
    color: theme.palette.text.secondary,
    maxWidth: "48ch",
    marginBottom: theme.spacing(4),
  },
  capabilities: {
    display: "flex",
    flexWrap: "wrap",
    borderTop: `1px solid ${theme.palette.divider}`,
    paddingTop: theme.spacing(2),
  },
  capability: {
    color: theme.palette.text.disabled,
    paddingRight: theme.spacing(2),
    marginRight: theme.spacing(2),
    borderRight: `1px solid ${theme.palette.divider}`,
    "&:last-child": { borderRight: "none", marginRight: 0, paddingRight: 0 },
  },
  nodesSlot: {
    position: "absolute",
    left: theme.spacing(2),
    bottom: theme.spacing(-2),
    display: "none",
    [theme.breakpoints.up("lg")]: { display: "block" },
  },
  formPanel: {
    position: "relative",
    zIndex: 1,
    flex: "1 1 auto",
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-start",
    padding: theme.spacing(2, 4, 6),
    [theme.breakpoints.up("md")]: {
      flex: "0 0 42%",
      alignItems: "center",
      padding: theme.spacing(8, 6),
    },
  },
  // Непрозрачный фон задаётся первым, blur — только апгрейдом в @supports:
  // в Firefox ESR без backdrop-filter карточка иначе стала бы просвечивающим пятном.
  card: {
    width: "100%",
    maxWidth: 420,
    padding: theme.spacing(5),
    borderRadius: 8,
    border: `1px solid ${theme.palette.divider}`,
    backgroundColor: theme.palette.background.paper,
    "@supports ((backdrop-filter: blur(1px)) or (-webkit-backdrop-filter: blur(1px)))": {
      backgroundColor:
        theme.palette.type === "dark" ? "rgba(255,255,255,0.06)" : "rgba(255,255,255,0.72)",
      backdropFilter: "blur(16px)",
    },
  },
  form: {
    width: "100%",
  },
  submit: {
    margin: theme.spacing(3, 0, 1),
    minHeight: 48,
  },
  // Было secondary.main — то есть «цвет ошибки» совпадал с цветом кнопки.
  error: {
    color: theme.palette.error.main,
  },
  footer: {
    position: "relative",
    zIndex: 1,
    display: "flex",
    alignItems: "center",
    // Не flex-gap: он деградирует в ноль отступа, а не во что-то приемлемое.
    "& > * + *": { marginLeft: 12 },
    color: theme.palette.text.disabled,
    borderTop: `1px solid ${theme.palette.divider}`,
    padding: theme.spacing(2, 4),
    [theme.breakpoints.up("md")]: {
      position: "absolute",
      bottom: 0,
      left: 0,
      right: 0,
      border: "none",
    },
  },
  homeButton: {
    position: "absolute",
    top: theme.spacing(2),
    right: theme.spacing(2),
    zIndex: 2,
  },
});

class AllureDockerSignIn extends Component {
  constructor(props) {
    super(props);
    this.state = this.initialState;
  }

  get initialState() {
    return {
      error: false,
      errorMessage: "",
      userTextField: {
        value: "",
      },
      passTextField: {
        value: "",
        show: false,
      },
    };
  }

  componentDidMount() { }

  signin = (event) => {
    event.preventDefault();
    axios
      .post("/login", {
        username: this.state.userTextField.value,
        password: this.state.passTextField.value,
      })
      .then((response) => {
        const expiresIn = response.data.data.expires_in;
        if (expiresIn !== 0) {
          const expirationDate = new Date(
            new Date().getTime() + expiresIn * 1000
          );
          localStorage.setItem("expirationDate", expirationDate);
        }
        setRoles(response.data.data.roles);
        // Приветствие показывается один раз на логин — даже тем, кто его уже видел.
        sessionStorage.setItem(WELCOME_PENDING_KEY, "1");
        this.props.isLoginRequired();
        this.props.history.replace("/");
      })
      .catch((error) => {
        this.showError(error.message);
      });
  };

  handleUserTextFieldChange = (event) => {
    const userTextField = { ...this.state.userTextField };
    userTextField.value = event.target.value;
    this.setState({ userTextField: userTextField });
  };

  handlePassTextFieldChange = (event) => {
    const passTextField = { ...this.state.passTextField };
    passTextField.value = event.target.value;
    this.setState({ passTextField: passTextField });
  };

  handleClickShowPassword = () => {
    const passTextField = { ...this.state.passTextField };
    passTextField.show = !this.state.passTextField.show;
    this.setState({ passTextField: passTextField });
  };

  handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  showError = (errorMessage) => {
    this.setState({ error: true, errorMessage });
  };

  resetStates = () => {
    this.setState(this.initialState);
  };

  goToHome = () => {
    redirectRoot();
  };

  render() {
    const { classes } = this.props;

    let isHomeAnOption;
    if (this.props.isHomeAnOption) {
      isHomeAnOption = (
        <IconButton
          className={classes.homeButton}
          color="inherit"
          aria-label="home"
          onClick={this.goToHome}
        >
          <HomeIcon />
        </IconButton>
      );
    }

    return (
      <div className={classes.root}>
        <KodeHaze position="topLeft" />
        {isHomeAnOption}

        <div className={classes.brandPanel}>
          <KodeGrid />
          <div className={classes.nodesSlot}>
            <KodeNodes />
          </div>
          <div className={classes.brandContent}>
            <Typography variant="overline" className={classes.eyebrow}>
              KODE · QA Platform
            </Typography>
            <Typography variant="h1" component="h1" className={classes.headline}>
              Allure reports for
              <span className={classes.headlineAccent}>KODE</span>
            </Typography>
            <Typography variant="overline" className={classes.poweredBy}>
              Powered by AI Transformation
            </Typography>
            <Typography className={classes.lead}>
              Every service, every suite, one place. Sign in to browse reports, history and
              trends.
            </Typography>
            <div className={classes.capabilities}>
              {["Allure reports", "History & trends", "Per-project access"].map((label) => (
                <Typography variant="overline" className={classes.capability} key={label}>
                  {label}
                </Typography>
              ))}
            </div>
          </div>
        </div>

        <div className={classes.formPanel}>
          <div className={classes.card}>
            <Typography variant="overline" className={classes.eyebrow}>
              Sign in
            </Typography>
            <form className={classes.form} noValidate onSubmit={this.signin}>
              <TextField
                error={this.state.userTextField.error}
                value={this.state.userTextField.value}
                onChange={this.handleUserTextFieldChange}
                variant="outlined"
                margin="normal"
                required
                fullWidth
                id="user"
                label="User"
                name="user"
                autoComplete="user"
                autoFocus
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <AccountCircle />
                    </InputAdornment>
                  ),
                }}
              />
              <TextField
                error={this.state.passTextField.error}
                value={this.state.passTextField.value}
                type={this.state.passTextField.show ? "text" : "password"}
                onChange={this.handlePassTextFieldChange}
                variant="outlined"
                margin="normal"
                required
                fullWidth
                name="password"
                label="Password"
                id="password"
                autoComplete="current-password"
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={this.handleClickShowPassword}
                        onMouseDown={this.handleMouseDownPassword}
                      >
                        {this.state.passTextField.show ? (
                          <Visibility />
                        ) : (
                            <VisibilityOff />
                          )}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />

              <FormHelperText className={classes.error}>
                {this.state.errorMessage}
              </FormHelperText>

              <Button
                type="submit"
                fullWidth
                variant="contained"
                color="primary"
                className={classes.submit}
              >
                Sign In
              </Button>
            </form>
          </div>
        </div>

        <div className={classes.footer}>
          <KodeLogo height={14} />
          <Typography variant="caption">
            QA Platform · {new Date().getFullYear()}
          </Typography>
        </div>
      </div>
    );
  }
}

export default withStyles(styles, { withTheme: true })(
  withRouter(AllureDockerSignIn)
);
